import type React from "react";

import { PatientOverview } from "../components/Overview";

export const Overview: React.FC = () => {
  return (
    <>
      <PatientOverview />
    </>
  );
};
